import { render } from "./CreditCard.vue?vue&type=template&id=4e898eef"
import script from "./CreditCard.vue?vue&type=script&lang=js"
export * from "./CreditCard.vue?vue&type=script&lang=js"
script.render = render

export default script